<template>
  <div>
    <div v-if="!short" style="display: flex; justify-content: space-between; align-items: center">
      <v-btn fab depressed color="black" dark small :to="`/regalos/campaign/${campaign_id}/idea/${idea_id}`"
        ><v-icon>mdi-chevron-left</v-icon></v-btn
      >
      <!-- menu -->
      <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab depressed small color="success" v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-horizontal</v-icon>
          </v-btn>
        </template>
        <v-list style="border-radius: 12px">
          <v-list-item @click="$router.push(`./edit/`)">
            <v-list-item-title>Editar detalles</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteme">
            <v-list-item-title style="color: red">Eliminar</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div>
      <!-- breadcrumb -->
      <div v-if="false">
        <router-link to="/regalos">Regalos</router-link>
        &gt;
        <router-link :to="`/regalos/campaign/${campaign_id}`">
          {{ campaign.title }}
        </router-link>
        &gt;
        <router-link :to="`/regalos/campaign/${campaign_id}/idea/${idea_id}`">
          {{ idea.title }}
        </router-link>
      </div>

      <!-- title -->
      <div style="font-size: 150%; font-weight: bold">
        {{ trimText(option.title || 'Sin título', 50) }}
        <span v-if="false" class="modern-link" @click="goToEdit">editar</span>
      </div>
      <!-- image -->
      <div style="margin-top: 20px">
        <img
          :src="option.image_url || 'https://www.svgrepo.com/show/508699/landscape-placeholder.svg'"
          alt=""
          :style="{
            width: '90%',
            aspectRatio: 1,
            objectFit: 'contain',
            display: 'block',
            margin: 'auto',
            filter: loading ? 'blur(6px)' : '',
          }"
        />
      </div>

      <!-- image and key data-->
      <div style="display: flex; gap: 5px">
        <div style="text-align: left">
          <div style="font-size: 24pt">{{ option.price }} {{ option.currency || 'EUR' }}</div>
          <p>{{ trimText(option.description, 150) }}</p>
        </div>
      </div>

      <!-- link -->
      <div v-if="option.link">
        <a :href="option.link" target="_blank" rel="noopener noreferrer">Ver en {{ hostname(option.link) }}</a>
      </div>

      <!-- status -->
      <div v-if="false">
        <v-chip-group v-model="option.status">
          <v-chip value="pending" color="primary" :outlined="option.status != 'pending'">pending</v-chip>
          <v-chip value="archived" color="error" :outlined="option.status != 'archived'">archived</v-chip>
          <v-chip value="done" color="success" :outlined="option.status != 'done'">done</v-chip>
        </v-chip-group>
      </div>

      <!-- purchased-->
      <div>
        <v-checkbox
          v-model="option.purchased"
          :label="`Comprado por ${option.price} ${option.currency || 'EUR'}`"
          hide-details
          :disabled="option.discarded"
        ></v-checkbox>
        <v-checkbox v-show="!option.purchased" v-model="option.discarded" label="Descartar esta opción"></v-checkbox>
        <div v-if="option.purchased">
          <!-- payment -->
          <div style="margin-top: 10px">
            <ChipDropdown label="Pagado por" :items="payers" v-model="option.paidBy" />
            <v-text-field v-if="false" v-model="option.paidAt" label="Fecha pago" outlined></v-text-field>
          </div>
        </div>

        <!-- mark whole idea as completed (visible only if no other ideas open)-->
        <div
          v-if="
            option.purchased &&
            idea.options.filter((i) => !i.purchased && !i.discarded && i.id != option_id).length == 0
          "
        >
          <v-checkbox
            v-model="idea.completed"
            @change="markIdeaAsCompleted($event)"
            label="Idea completada"
          ></v-checkbox>
        </div>

        <!-- shipment -->
        <div v-if="option.purchased">
          <v-checkbox v-model="option.received" label="Producto recibido"></v-checkbox>
          <v-text-field
            v-if="option.received"
            v-model="option.received_notes"
            label="received_notes"
            outlined
          ></v-text-field>
        </div>

        <!-- returns -->
        <div v-if="option.purchased">
          <v-checkbox v-model="option.returned" label="Devuelto"></v-checkbox>
        </div>
      </div>

      <!-- comments -->
      <div style="margin-top: 30px">
        <h2>Comentarios</h2>
        <div v-for="comment in option.comments" :key="comment.id">
          [{{ comment.author }}]
          {{ comment.text }}
        </div>
        <div style="border: 1px solid #ccc; background-color: rgba(0, 0, 0, 0.1); border-radius: 12px; padding: 5px">
          <v-text-field outlined label="comentario" v-model="newComment"></v-text-field>
          <v-btn v-if="newComment" depressed color="primary" @click="addComment">enviar</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/assets/api'
import ChipDropdown from '@/components/ChipDropdown.vue'
import { v4 as uuidv4 } from 'uuid'
import { mapGetters } from 'vuex'
import { nickname } from './regalos-data'

export default {
  components: {
    ChipDropdown,
  },
  props: {
    campaign_id: {
      type: String,
      default: '',
    },
    idea_id: { type: String, default: '' },
    option_id: { type: String, default: '' },
    short: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      campaign: {},
      idea: {},
      option: {},
      newComment: '',
    }
  },
  watch: {
    option: {
      deep: true,
      handler(newValue, oldValue) {
        //avoid post when just loaded the data
        if (oldValue.id) {
          this.save()
        }
      },
    },
  },
  computed: {
    ...mapGetters(['username']),
    payers() {
      return this.campaign.owners.map((o) => ({
        text: nickname(o, this.campaign, this.username),
        value: o,
      }))
    },
  },
  methods: {
    trimText(text, len = 100) {
      if (!text) return ''
      if (text.length > len + 5) return text.slice(0, len) + '...'
      return text
    },
    hostname(url) {
      try {
        return new URL(url).hostname
      } catch (error) {
        return ''
      }
    },
    addComment() {
      if (!this.newComment) return

      if (!this.option.comments) this.option.comments = []
      this.option.comments.push({
        id: uuidv4(),
        author: this.username,
        text: this.newComment,
        date: new Date().toISOString(),
      })
      this.save()
      this.newComment = ''
    },
    async save() {
      this.loading = true
      let x = await api.apiFetch(`/regalos/option?id=${this.campaign_id}`, {
        method: 'POST',
        body: JSON.stringify(this.option),
      })
      this.loading = false
      if (!x.ok) return alert('something failed')
      let j = await x.json()
      //this.fetchData()
    },
    async deleteme() {
      if (!confirm('Are you sure you want to delete this option?')) return
      this.loading = true
      const path = `/regalos/option?campaign_id=${this.campaign_id}&idea_id=${this.idea_id}&option_id=${this.option_id}`
      let x = await api.apiFetch(path, {
        method: 'DELETE',
        body: JSON.stringify(this.option),
      })
      this.loading = false
      if (!x.ok) return alert('something failed')
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${this.idea_id}`)
    },
    async markIdeaAsCompleted(val) {
      //fetch the idea, update, save
      await this.fetchData() //make sure we have the latest data
      const idea = this.idea
      idea.completed = val
      this.loading = true
      let x = await api.apiFetch(`/regalos/idea?id=${this.campaign_id}`, {
        method: 'POST',
        body: JSON.stringify(idea),
      })
      this.loading = false
    },
    goToEdit() {
      this.$router.push(`/regalos/campaign/${this.campaign_id}/idea/${this.idea_id}/option/${this.option_id}/edit`)
    },
    async fetchData() {
      this.loading = true
      let x = await api.apiFetch(`/regalos/campaign?id=${this.campaign_id}`)
      this.loading = false
      if (!x.ok) return alert('something failed')
      let j = await x.json()
      this.campaign = j
      if (!j.ideas) j.ideas = []
      const idea = j.ideas.find((i) => i.id == this.idea_id)
      if (!idea) return alert('idea not found')
      this.idea = idea

      if (!idea.options) idea.options = []
      const option = idea.options.find((i) => i.id == this.option_id)
      if (!option.status) option.status = 'pending'
      if (!option.campaign_id) option.campaign_id = this.campaign_id
      if (!option.idea_id) option.idea_id = this.idea_id
      this.option = { ...option }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped></style>
